import { SLUG_RULES, deriveSlug } from "@eduviaos/shared";

/**
 * Institution-admin host for `slug` on the environment this SA runs on:
 * `sa-stage` → `<slug>--ia-stage`, `sa-pr-N` → `<slug>--ia-pr-N`,
 * `sa` → `<slug>--ia`. Local dev previews the stage address.
 */
export function tenantPortalHost(slug: string, hostname: string): string {
  const label = hostname.split(".")[0]?.toLowerCase() ?? "";
  const pr = /^sa-pr-(\d+)$/.exec(label);
  const suffix = pr ? `--ia-pr-${pr[1]}` : label === "sa" ? "--ia" : "--ia-stage";
  return `${slug}${suffix}.eduviaos.com`;
}

/**
 * Slug for a cloned assessment template. A new name wins; otherwise
 * cross-tenant clones keep the source slug and same-tenant forks get a
 * `-copy` suffix so they don't collide with the original.
 */
export function deriveCloneSlug(
  sourceSlug: string,
  newName: string,
  cloningIntoSource: boolean,
): string {
  if (newName) return deriveSlug(newName, SLUG_RULES.assessment);
  if (!cloningIntoSource) return sourceSlug;
  const suffix = "-copy";
  const stem = sourceSlug.slice(0, SLUG_RULES.assessment.maxLength - suffix.length);
  return `${stem.replace(/-+$/, "")}${suffix}`;
}
